export default {
    labels: {
        cancel: "Cancel",
        current: "current step:",
        pagination: "Pagination",
        finish: "Register",
        next: "Next",
        previous: "Previous",
        loading: "Loading ...",
    }
}
